<template>
    <div>
        <div class="lista-smge" v-if="!loading">
            <ul>
                <li>
                    <h3>Selecione uma data</h3>
                </li>
                <li v-for="(item, i) in datas" :key="i" @click="dataSelecionada(item)">
                    <div class="box-data">
                        <h3>{{ $moment(item).format('DD/MM/YYYY') }}</h3>
                        <span class="freq-sub-titulo">{{ getDiaSemana(item) }}</span>
                    </div>
                    <i class="fas fa-angle-right"></i>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>

export default {
    props: ['param'],
    data: () => ({
        loading: true,
        datas: []
    }),
    mounted () {

        if(this.param.datas[0] < this.param.datas[1]){
            this.datas = this.param.datas.reverse();
        }else{
            this.datas = this.param.datas;
        }

        this.loading = false;
    },
    methods:{
        dataSelecionada(data){
            this.$router.push(`/admin/diario/frequencia?data=${data}`);  
        },
        getDiaSemana(ref){

            let dia = this.$moment(ref).format('dddd');

            switch (dia) {
                case 'Monday':
                    return 'Segunda-feira'
                break;
                case 'Tuesday':
                    return 'Terça-feira'
                break;
                case 'Wednesday':
                    return 'Quarta-feira'
                break;
                case 'Thursday':
                    return 'Quinta-feira'
                break;
                case 'Friday':
                    return 'Sexta-feira'
                break;
                case 'Saturday':
                    return 'Sábado'
                break;
                case 'Sunday':
                    return 'Domingo'
                break;
            }
        }
    }
}
</script>
<style>
    .lista-smge {
        max-width: 100%;
        margin: 0 auto;
        z-index: 1;
    }
    .lista-smge ul {
        list-style: none;
        padding-left: 0px;
    }
    .lista-smge li:not(:first-child) {
        color: #404040;
        border-bottom: 1px solid #eaeaea;
        cursor: pointer;
        padding: 10px;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .lista-smge li:first-child {
        padding: 10px;
        border-top: 1px solid #eaeaea;
        background-color: #f1f1f1;
    }
    .lista-smge h3 {
        margin: 0;
        font-weight: 400;
        color: #2d2d2d;
        font-size: 16px;
        letter-spacing: -.5px;
    }
    .lista-smge .freq-sub-titulo{
        font-weight: 300;
        color: #818181;
    }
    .lista-smge .box-data {
        padding-left: 10px;
    }
</style>
